import React from "react";
import { Images } from "./Images";
import "../CSS/Work.css";
// import { useNavigate } from "react-router-dom";

const Work=()=>{
    return(
    
            <div className="qqqqq">
                <div className="workexperience">
                    <h1 className="myworkexperience">My Work Experience</h1>
                    <div className="Venzo">
                        <div className="venzologo">
                        <img src={Images.Venzo} alt="venzo"></img>
                        </div>
                        <div className="Product">
                        <h1 className="titleproduct">Product Designer</h1>
                        <p className="subtitle">Venzo Technologies . Full Time</p>
                        <p className="subbtitle">June 2021 - Present</p>
                        </div>
                        </div>
                        <div className="Icanio">
                        <img src={Images.Icanio} alt="icanio" className="icaniologo"></img>
                        <div className="Icaniofull">
                            <div className="UXUI">
                            <h1 className="Fullheading">UI/UX Designer</h1>
                            <p className="Fullsubtitle">Icanio Technologies . Full Time</p>
                            <p className="Fullsubbtitle">Mar 2021 - May 2021</p>
                            </div>
                            <br>
                            </br>
                            <div className="Icaniointern">
                            <h1 className="Internheading">UI/UX Designer</h1>
                            <p className="internsubtitle">Icanio Technologies . Internship</p>
                            <p className="internsubbtitle">Nov 2020 - Feb 2021</p>
                            </div>
                        </div>
                        
                    </div> 
            </div>
            <div className="certificate">
                <h1 className="Mycertificate">CERTIFICATION</h1>
                <div className="Certificatecard">
                    <Certifi certititle={"Foundations of User Experience (UX) Design"} url={"https://coursera.org/share/3b46fab94164b6fd1a7ee234fb459444"} />
                    <Certifi certititle={"Start the UX Design Process: Empathize, Define, and Ideate"} url={"https://www.coursera.org/account/accomplishments/certificate/MAT234TVHQUN"} />
                    <Certifi certititle={"Build the Wireframes and Low-Fidelity Prototypes"} url={"https://www.coursera.org/account/accomplishments/certificate/APDMNGKKLJTN"} />
                    <Certifi certititle={"Conduct UX Research and Test Early Concepts"} url={"https://www.coursera.org/account/accomplishments/certificate/9ZP7MNC96KBX"} />
                </div>

            </div>
            </div>
    )
}

const Certifi=({certititle, url})=>{
    // const navigate = useNavigate();
    return(
        <div className="totalcertifi">
            <h1 className="Certificatetitle">{certititle}</h1>
            <a href={url} target="_blank"  className="Navigation" >
            {/* onClick={()=>navigate(`/${url}`)} */}
                <p className="viewcertificatetitle">View Certificate</p>
                <img src={Images.Arrow} alt="Arrow_Icon"></img>
            </a>
        </div>
    )
}


export default Work;